import React, { useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  Container,
  Box,
  Divider,
  CardContent,
  Button,
  Typography,
  FormControl,
  OutlinedInput,
  InputLabel,
  Snackbar,
  LinearProgress,
} from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import MainLogos from '../../assets/main-logos.svg';
import LogoExtended from '../../assets/extendedLogo.svg';
import api from '../../services/api';

import { optionStyles } from './styles';

interface FormData {
  usarname: string;
  password: string;
}

interface User {
  groups: string[];
}

const defaultWarn: {
  message: string;
  open: boolean;
  type?: 'success' | 'error';
} = {
  message: '',
  open: false,
  type: 'success',
};

const ForgotPassword: React.FC = () => {
  const classes = optionStyles();
  const [err, setErr] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [openWarn, setOpenWarn] = useState<{
    message: string;
    open: boolean;
    type?: 'success' | 'error';
  }>(defaultWarn);
  const history = useHistory();
  const [email, setEmail] = useState<string>('');
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = async (data = { email }) => {
    setLoading(true);
    await api
      .post<string>('/recovery-pass/', data)
      .then((res) => {
        setLoading(false);
        setOpenWarn({ message: res.data, open: true, type: 'success' });
        setTimeout(() => {
          history.push('/login');
        }, 4000);
      })
      .catch((e) => {
        setOpenWarn({
          message: 'Erro ao recuperar senha. Tente novamente mais tarde.',
          open: true,
          type: 'error',
        });
        setErr(true);
        setLoading(false);
      });
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };
  return (
    <Container maxWidth="xl" className={classes.rootContainer}>
      <Box className={classes.rootCard}>
        <CardContent className={classes.cardContent}>
          <img src={LogoExtended} alt="Logo VIDA" width="200" className={classes.logo} />
          <Divider className={classes.divider} orientation="horizontal" />
          <Typography variant="h6" style={{ color: '#404040', marginBottom: '5%' }}>
            Recuperar senha
          </Typography>
          {err ? (
            <Typography
              variant="subtitle2"
              style={{ color: '#90002B', marginBottom: '5%' }}
            >
              E-mail não cadastrado.
            </Typography>
          ) : (
            <Typography variant="body2" className={classes.text}>
              As instruções de recuperação da sua senha serão enviadas para o e-mail da
              sua conta. Para isso, informe o e-mail da sua conta abaixo.
            </Typography>
          )}

          <Form className={classes.rootForm} ref={formRef} onSubmit={handleSubmit}>
            <FormControl variant="outlined" disabled={loading}>
              <InputLabel htmlFor="email">E-mail de recuperação</InputLabel>
              <OutlinedInput
                id="email"
                name="email"
                label="E-mail de recuperação"
                type="email"
                required
                placeholder="E-mail de recuperação"
                value={email}
                onChange={handleEmailChange}
              />
            </FormControl>
            {loading && <LinearProgress />}
            <Button
              variant="outlined"
              className={classes.rootButton}
              onClick={() => handleSubmit()}
            >
              Enviar
            </Button>
          </Form>
          <Link className={classes.link} to="/login">
            Já possuo acesso
          </Link>
        </CardContent>
        <img src={MainLogos} alt="Logo VIDA" className={classes.mainLogos} />
        <Snackbar
          open={openWarn.open}
          autoHideDuration={4000}
          onClose={() => setOpenWarn(defaultWarn)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        >
          <MuiAlert
            onClose={() => setOpenWarn(defaultWarn)}
            severity={openWarn.type}
            elevation={6}
            variant="filled"
          >
            {openWarn.message}
          </MuiAlert>
        </Snackbar>
      </Box>
    </Container>
  );
};

export default ForgotPassword;
